"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

// On component load, turns off floating fresh chat, on component unmount, turns back on
var useFreshChatDeactivate = function useFreshChatDeactivate(manualActivation) {
  if (manualActivation === void 0) {
    manualActivation = false;
  }

  var deactivate = function deactivate() {
    var _window$fcWidget;

    if (typeof window !== "undefined" && (_window$fcWidget = window.fcWidget) != null && _window$fcWidget.hide) {
      window.fcWidget.hide();
      return true;
    }

    return false;
  };

  var activate = function activate() {
    var _window$fcWidget2;

    if (typeof window !== "undefined" && (_window$fcWidget2 = window.fcWidget) != null && _window$fcWidget2.show) {
      window.fcWidget.show();
      return true;
    }

    return false;
  };

  (0, _react.useEffect)( // eslint-disable-next-line consistent-return
  function () {
    var complete = deactivate();

    if (!complete) {
      setTimeout(deactivate, 1000);
    }

    if (!manualActivation) {
      return activate;
    }
  }, [manualActivation]);
  return [deactivate, activate];
};

var _default = useFreshChatDeactivate;
exports["default"] = _default;